import React from 'react';
import AuthService from './authService.js';
import serviceHelper from '../Helpers/serviceHelper.js';
import TierItem from '../Domain/TierItem.js';

export default class TierService extends React.Component {
  static GetTierList(searchItem) {
    const searchParams = {
      Command: '',
      OrderBy: '',
      OrderDirection: '',
      PageNumber: 0,
      NumberOfElementsOnAPage: 0,
      SearchItem: searchItem,
    };
    const url = `/api/Tier/GetAllTierAsync?searchParams=${JSON.stringify(searchParams)}&clearCache=true`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new TierItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static CalculateTier(items, pricingDetail) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new TierItem(item);
        newItem.calculate(pricingDetail);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static Remove(TierId) {
    const url = `/api/Tier/RemoveTier/${TierId}`;
    return AuthService.getInstance().CallBackendFunctionDelete(url);
  }

  static Post(item) {
    const url = '/api/Tier/PostTier/';
    const tier = [];
    item.forEach((t) => {
      const tierTOString = serviceHelper.ConvertAllPropertyToString(t);
      tier.push(tierTOString);
    });
    const json = JSON.stringify(item);

    return AuthService.getInstance().CallBackendFunctionPost(url, json);
  }

  static CalculateOverallTier(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new TierItem(item);
        newItem.calculate(item.pricingDetail);
        newItem.VPricingDetailBaseItem = item.pricingDetail;
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }
}
